import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-kamona-custom-button',
    templateUrl: './kamona-custom-button.component.html',
    styleUrls: ['./kamona-custom-button.component.scss'],
})
export class KamonaButtonComponent implements OnInit {
    @Input() prefix: any;
    @Input() suffix: any;
    @Input() text: string;
    @Input() isDisabled: boolean;
    @Input() behaviour: 'submit' | 'button' = 'submit';
    // @Input() isGhost: boolean //To remove backgorund
    @Input() isSubmitting: boolean; // To add loading status
    @Input() isBlock: boolean; // To get the stretch
    @Input() type: 'primary' | 'default' | 'link';
    @Input() state:
        | 'primary'
        | 'lightprimary'
        | 'decline'
        | 'decline-link'
        | 'disabled'
        | 'secondary'
        | 'lightsecondary'
        | 'outline'
        | 'disabledoutline'
        | 'lightoutline'
        | 'text'
        | 'disabledtext' // To get state
        | 'warning';
    @Input() theme: 'twotone' | 'fill' | 'outline' = 'outline';

    @Output() submitForm: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}
}
